import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import { ElementHTML } from '@helpers/helper.rendering'
const AboutUs13 = (props: RealEstateDataPageComponentData) => {
  const { title, paragraphs, paragraphElement, titleElement } = props

  return (
    <section className="p-y-config aboutUs about-13">
      <Container fluid>
        <Row className="mb-lg-5 mb-4">
          <Col lg={2}>
            {title?.split('\n').map((tit, index) => (
              <ElementHTML
                children={tit!}
                key={index}
                elementType={titleElement || 'h2'}
                className="section-name"
              />
            ))}
          </Col>
          <Col lg={{ span: 10 }}>
            {paragraphs?.map((paragraph, index) =>
              paragraph == '' ? (
                <br key={index} />
              ) : (
                <ElementHTML
                  key={index}
                  children={paragraph}
                  elementType={paragraphElement || 'p'}
                  className="sub-section"
                />
              ),
            )}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs13
